<template>
  <div class="btn-select-wash-vial">
    <Btn height="s" icon-left="gradient" :disabled="isDisabled" @click="showPopup">
      <slot>Wash needle</slot>
    </Btn>

    <BottomSheet :isShow="isShowPopup" title="Wash needle" @hide="hidePopup">
      <WashVialSelector class="btn-select-wash-vial__selector" @select="selectVial" />
    </BottomSheet>
  </div>
</template>

<script>
  import Btn from '@/uikitBase/btns/Btn';
  import BottomSheet from '@/uikitBase/popups/BottomSheet';
  import WashVialSelector from '../private/WashVialSelector';
  import { props, EVENT_SELECT } from '../shared/config.ts';

  export default {
    name: 'MobileBtnSelectWashVial',

    components: {
      Btn,
      BottomSheet,
      WashVialSelector,
    },

    props,

    data: () => ({
      isShowPopup: false,
    }),

    methods: {
      showPopup() {
        this.isShowPopup = true;
      },

      hidePopup() {
        this.isShowPopup = false;
      },

      selectVial(vial) {
        this.$emit(EVENT_SELECT, vial);
        this.hidePopup();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .btn-select-wash-vial {
    display: flex;

    &__selector {
      margin-top: 20px;
    }
  }
</style>
